module.exports = __webpack_public_path__ + "static/grantbook-logo-b3d241e1bfae2fc18d751f5922a39489.png";